// MovioHub i18n — EN, TR, DE, ES, FR
// Compact dictionaries focused on visible UI strings.

export const SUPPORTED_LOCALES = ["en", "tr", "de", "es", "fr"];

const DICT = {
  en: {
    brand_tagline: "A curated streaming atlas",
    hero_title_1: "Find where to watch",
    hero_title_2: "anything,",
    hero_title_3: "in any language, anywhere.",
    hero_subtitle: "Search any film or series and instantly see platforms, countries, audio dubs, subtitles, and which cuts are streaming where.",
    search_placeholder: "Try \"Dune\", \"The Bear\", \"Oppenheimer\"…",
    search_btn: "Search",
    trending: "Trending:",
    browse_catalog: "Browse the cinematic catalog",
    results_for: "Results for",
    no_results_title: "No titles match your lens",
    no_results_sub: "Try clearing filters or another search.",
    refine: "Refine",
    platform: "Platform",
    country: "Country",
    language: "Language",
    all_platforms: "All platforms",
    all_countries: "All countries",
    all_languages: "All languages",
    type: "Type",
    all_types: "All types",
    movies_only: "Films",
    tv_only: "Series",
    year_range: "Year",
    sort_by: "Sort",
    sort_popularity: "Popularity",
    sort_year: "Newest",
    clear: "Clear",
    sign_in: "Sign in with Google",
    my_alerts: "My Alerts",
    dashboard: "Dashboard",
    sign_out: "Sign out",
    where_to_watch: "Where to watch",
    different_versions: "Different versions",
    notify_tr_dub: "Notify me — Turkish dub",
    alert_armed: "Alert armed",
    already_tr_dub: "Turkish dubbing already available",
    back: "Back",
    feature_film: "Feature Film",
    series: "Series",
    title_unavailable: "Not available in your country",
    title_unavailable_sub: "Here's where it IS available legally:",
    fan_board: "Fan Board",
    fan_board_sub: "Discuss this title with other fans.",
    write_post: "Share your thoughts or questions…",
    post_btn: "Post",
    reply: "Reply",
    write_reply: "Write a reply…",
    mark_spoiler: "Mark as spoiler",
    spoiler_warning: "Spoiler — click to reveal",
    sign_in_to_post: "Sign in to join the conversation",
    critic_videos: "Critic Reviews",
    critic_videos_sub: "Video reviews from critics on YouTube & Instagram.",
    add_video: "Add a review",
    embed_video: "Paste YouTube or Instagram URL…",
    submit: "Submit",
    in_cinemas: "Now in Cinemas",
    in_cinemas_sub: "Catch these on the big screen this week.",
    buy_tickets: "Buy tickets",
    profile: "My Profile",
    watchlist: "Watchlist",
    watched: "Watched",
    following: "Following",
    inbox: "Inbox",
    for_you: "For You",
    based_on: "Based on your interests in",
    add_to_watchlist: "Add to Watchlist",
    mark_watched: "Mark Watched",
    follow_title: "Follow updates",
    in_watchlist: "In Watchlist",
    marked_watched: "Watched",
    following_btn: "Following",
    remove: "Remove",
    no_watchlist: "Your watchlist is empty",
    no_watched: "You haven't marked anything as watched yet",
    no_following: "You're not following any titles yet",
    no_messages: "No conversations yet",
    new_message: "Write a message…",
    send: "Send",
    locale_picker: "Language",
  },
  tr: {
    brand_tagline: "Akış platformu atlası",
    hero_title_1: "Her şeyi nerede izleyeceğinizi",
    hero_title_2: "bulun,",
    hero_title_3: "her dilde, her yerde.",
    hero_subtitle: "Herhangi bir film veya diziyi arayın; platformları, ülkeleri, dublajları, altyazıları ve hangi versiyonun nerede yayınlandığını anında görün.",
    search_placeholder: "\"Dune\", \"The Bear\", \"Oppenheimer\" deneyin…",
    search_btn: "Ara",
    trending: "Trendler:",
    browse_catalog: "Sinematik kataloğu keşfet",
    results_for: "Sonuçlar",
    no_results_title: "Aramanızla eşleşen başlık yok",
    no_results_sub: "Filtreleri temizleyin veya farklı bir arama yapın.",
    refine: "Filtrele",
    platform: "Platform",
    country: "Ülke",
    language: "Dil",
    all_platforms: "Tüm platformlar",
    all_countries: "Tüm ülkeler",
    all_languages: "Tüm diller",
    type: "Tür",
    all_types: "Hepsi",
    movies_only: "Filmler",
    tv_only: "Diziler",
    year_range: "Yıl",
    sort_by: "Sırala",
    sort_popularity: "Popülerlik",
    sort_year: "En Yeni",
    clear: "Temizle",
    sign_in: "Google ile Giriş",
    my_alerts: "Bildirimlerim",
    dashboard: "Panel",
    sign_out: "Çıkış",
    where_to_watch: "Nerede izlenir",
    different_versions: "Farklı versiyonlar",
    notify_tr_dub: "Türkçe dublaj çıkınca haber ver",
    alert_armed: "Bildirim kuruldu",
    already_tr_dub: "Türkçe dublaj zaten mevcut",
    back: "Geri",
    feature_film: "Sinema Filmi",
    series: "Dizi",
    title_unavailable: "Ülkenizde mevcut değil",
    title_unavailable_sub: "Yasal olarak şu ülkelerde mevcut:",
    fan_board: "Hayran Panosu",
    fan_board_sub: "Bu yapımı diğer hayranlarla tartışın.",
    write_post: "Düşüncelerinizi veya sorularınızı paylaşın…",
    post_btn: "Gönder",
    reply: "Yanıtla",
    write_reply: "Yanıt yazın…",
    mark_spoiler: "Spoiler olarak işaretle",
    spoiler_warning: "Spoiler — görmek için tıklayın",
    sign_in_to_post: "Tartışmaya katılmak için giriş yapın",
    critic_videos: "Eleştirmen İncelemeleri",
    critic_videos_sub: "YouTube ve Instagram'dan eleştirmen videoları.",
    add_video: "İnceleme ekle",
    embed_video: "YouTube veya Instagram URL'si yapıştırın…",
    submit: "Gönder",
    in_cinemas: "Şimdi Sinemalarda",
    in_cinemas_sub: "Bu hafta sinemalarda gösterimde olan filmler.",
    buy_tickets: "Bilet al",
    profile: "Profilim",
    watchlist: "İzleme Listesi",
    watched: "İzlenenler",
    following: "Takip Edilen",
    inbox: "Mesajlar",
    for_you: "Sana Özel",
    based_on: "İlgi alanlarına göre",
    add_to_watchlist: "Listeye Ekle",
    mark_watched: "İzlendi İşaretle",
    follow_title: "Güncellemeleri takip et",
    in_watchlist: "Listede",
    marked_watched: "İzlendi",
    following_btn: "Takipte",
    remove: "Kaldır",
    no_watchlist: "İzleme listen boş",
    no_watched: "Henüz hiçbir şeyi izlendi olarak işaretlemedin",
    no_following: "Henüz takip ettiğin başlık yok",
    no_messages: "Henüz konuşma yok",
    new_message: "Mesaj yazın…",
    send: "Gönder",
    locale_picker: "Dil",
  },
  de: {
    brand_tagline: "Ein kuratierter Streaming-Atlas",
    hero_title_1: "Finde, wo du",
    hero_title_2: "alles",
    hero_title_3: "schauen kannst — in jeder Sprache, überall.",
    hero_subtitle: "Suche jeden Film oder jede Serie und sieh sofort Plattformen, Länder, Synchronisationen, Untertitel und welche Schnitte wo verfügbar sind.",
    search_placeholder: "Probiere \"Dune\", \"The Bear\", \"Oppenheimer\"…",
    search_btn: "Suchen",
    trending: "Trends:",
    browse_catalog: "Den filmischen Katalog erkunden",
    results_for: "Ergebnisse für",
    no_results_title: "Keine Titel gefunden",
    no_results_sub: "Filter zurücksetzen oder neu suchen.",
    refine: "Filter",
    platform: "Plattform",
    country: "Land",
    language: "Sprache",
    all_platforms: "Alle Plattformen",
    all_countries: "Alle Länder",
    all_languages: "Alle Sprachen",
    type: "Typ",
    all_types: "Alle",
    movies_only: "Filme",
    tv_only: "Serien",
    year_range: "Jahr",
    sort_by: "Sortieren",
    sort_popularity: "Beliebtheit",
    sort_year: "Neueste",
    clear: "Löschen",
    sign_in: "Mit Google anmelden",
    my_alerts: "Meine Alerts",
    dashboard: "Dashboard",
    sign_out: "Abmelden",
    where_to_watch: "Wo zu sehen",
    different_versions: "Verschiedene Schnitte",
    notify_tr_dub: "Benachrichtigen bei türk. Synchro",
    alert_armed: "Alert aktiv",
    already_tr_dub: "Türkische Synchro bereits verfügbar",
    back: "Zurück",
    feature_film: "Spielfilm",
    series: "Serie",
    title_unavailable: "In deinem Land nicht verfügbar",
    title_unavailable_sub: "Hier ist es legal verfügbar:",
    fan_board: "Fan-Board",
    fan_board_sub: "Diskutiere diesen Titel mit anderen Fans.",
    write_post: "Teile deine Gedanken oder Fragen…",
    post_btn: "Posten",
    reply: "Antworten",
    write_reply: "Antwort schreiben…",
    mark_spoiler: "Als Spoiler markieren",
    spoiler_warning: "Spoiler — zum Anzeigen klicken",
    sign_in_to_post: "Anmelden, um teilzunehmen",
    critic_videos: "Kritiker-Reviews",
    critic_videos_sub: "Videos von Kritikern auf YouTube & Instagram.",
    add_video: "Review hinzufügen",
    embed_video: "YouTube oder Instagram URL einfügen…",
    submit: "Senden",
    in_cinemas: "Jetzt im Kino",
    in_cinemas_sub: "Diese Woche auf der großen Leinwand.",
    buy_tickets: "Tickets kaufen",
    profile: "Mein Profil",
    watchlist: "Watchlist",
    watched: "Gesehen",
    following: "Verfolgt",
    inbox: "Posteingang",
    for_you: "Für dich",
    based_on: "Basierend auf deinen Interessen an",
    add_to_watchlist: "Zur Watchlist",
    mark_watched: "Als gesehen",
    follow_title: "Verfolgen",
    in_watchlist: "In Watchlist",
    marked_watched: "Gesehen",
    following_btn: "Verfolgt",
    remove: "Entfernen",
    no_watchlist: "Deine Watchlist ist leer",
    no_watched: "Du hast noch nichts als gesehen markiert",
    no_following: "Du verfolgst noch keine Titel",
    no_messages: "Noch keine Konversationen",
    new_message: "Nachricht schreiben…",
    send: "Senden",
    locale_picker: "Sprache",
  },
  es: {
    brand_tagline: "Un atlas de streaming curado",
    hero_title_1: "Encuentra dónde ver",
    hero_title_2: "cualquier cosa,",
    hero_title_3: "en cualquier idioma, en cualquier lugar.",
    hero_subtitle: "Busca cualquier película o serie y mira al instante plataformas, países, doblajes, subtítulos y qué cortes se transmiten dónde.",
    search_placeholder: "Prueba \"Dune\", \"The Bear\", \"Oppenheimer\"…",
    search_btn: "Buscar",
    trending: "Tendencias:",
    browse_catalog: "Explora el catálogo cinematográfico",
    results_for: "Resultados para",
    no_results_title: "No hay títulos que coincidan",
    no_results_sub: "Borra filtros o intenta otra búsqueda.",
    refine: "Refinar",
    platform: "Plataforma",
    country: "País",
    language: "Idioma",
    all_platforms: "Todas las plataformas",
    all_countries: "Todos los países",
    all_languages: "Todos los idiomas",
    type: "Tipo",
    all_types: "Todos",
    movies_only: "Películas",
    tv_only: "Series",
    year_range: "Año",
    sort_by: "Ordenar",
    sort_popularity: "Popularidad",
    sort_year: "Más reciente",
    clear: "Limpiar",
    sign_in: "Iniciar sesión con Google",
    my_alerts: "Mis alertas",
    dashboard: "Panel",
    sign_out: "Cerrar sesión",
    where_to_watch: "Dónde verlo",
    different_versions: "Versiones diferentes",
    notify_tr_dub: "Avísame del doblaje turco",
    alert_armed: "Alerta activa",
    already_tr_dub: "Doblaje turco ya disponible",
    back: "Volver",
    feature_film: "Largometraje",
    series: "Serie",
    title_unavailable: "No disponible en tu país",
    title_unavailable_sub: "Aquí está disponible legalmente:",
    fan_board: "Foro de fans",
    fan_board_sub: "Comenta este título con otros fans.",
    write_post: "Comparte tus pensamientos o preguntas…",
    post_btn: "Publicar",
    reply: "Responder",
    write_reply: "Escribe una respuesta…",
    mark_spoiler: "Marcar como spoiler",
    spoiler_warning: "Spoiler — haz clic para ver",
    sign_in_to_post: "Inicia sesión para participar",
    critic_videos: "Reseñas de críticos",
    critic_videos_sub: "Videos de críticos en YouTube e Instagram.",
    add_video: "Añadir reseña",
    embed_video: "Pega URL de YouTube o Instagram…",
    submit: "Enviar",
    in_cinemas: "En cines ahora",
    in_cinemas_sub: "Películas en la gran pantalla esta semana.",
    buy_tickets: "Comprar entradas",
    profile: "Mi perfil",
    watchlist: "Por ver",
    watched: "Vistos",
    following: "Siguiendo",
    inbox: "Bandeja",
    for_you: "Para ti",
    based_on: "Basado en tus intereses en",
    add_to_watchlist: "Añadir a Por ver",
    mark_watched: "Marcar visto",
    follow_title: "Seguir actualizaciones",
    in_watchlist: "En la lista",
    marked_watched: "Visto",
    following_btn: "Siguiendo",
    remove: "Quitar",
    no_watchlist: "Tu lista está vacía",
    no_watched: "Aún no has marcado nada como visto",
    no_following: "Aún no sigues ningún título",
    no_messages: "Sin conversaciones aún",
    new_message: "Escribe un mensaje…",
    send: "Enviar",
    locale_picker: "Idioma",
  },
  fr: {
    brand_tagline: "Un atlas du streaming curaté",
    hero_title_1: "Trouve où regarder",
    hero_title_2: "n'importe quoi,",
    hero_title_3: "dans n'importe quelle langue, partout.",
    hero_subtitle: "Recherche un film ou une série et vois instantanément les plateformes, pays, doublages, sous-titres et quelles versions sont diffusées où.",
    search_placeholder: "Essaie \"Dune\", \"The Bear\", \"Oppenheimer\"…",
    search_btn: "Chercher",
    trending: "Tendances:",
    browse_catalog: "Parcours le catalogue cinématographique",
    results_for: "Résultats pour",
    no_results_title: "Aucun titre ne correspond",
    no_results_sub: "Efface les filtres ou essaie une autre recherche.",
    refine: "Affiner",
    platform: "Plateforme",
    country: "Pays",
    language: "Langue",
    all_platforms: "Toutes les plateformes",
    all_countries: "Tous les pays",
    all_languages: "Toutes les langues",
    type: "Type",
    all_types: "Tous",
    movies_only: "Films",
    tv_only: "Séries",
    year_range: "Année",
    sort_by: "Trier",
    sort_popularity: "Popularité",
    sort_year: "Plus récents",
    clear: "Effacer",
    sign_in: "Se connecter avec Google",
    my_alerts: "Mes alertes",
    dashboard: "Tableau de bord",
    sign_out: "Se déconnecter",
    where_to_watch: "Où regarder",
    different_versions: "Versions différentes",
    notify_tr_dub: "M'avertir du doublage turc",
    alert_armed: "Alerte active",
    already_tr_dub: "Doublage turc déjà disponible",
    back: "Retour",
    feature_film: "Long métrage",
    series: "Série",
    title_unavailable: "Non disponible dans votre pays",
    title_unavailable_sub: "Voici où c'est disponible légalement :",
    fan_board: "Forum des fans",
    fan_board_sub: "Discute de ce titre avec d'autres fans.",
    write_post: "Partage tes pensées ou questions…",
    post_btn: "Publier",
    reply: "Répondre",
    write_reply: "Écrire une réponse…",
    mark_spoiler: "Marquer comme spoiler",
    spoiler_warning: "Spoiler — cliquer pour révéler",
    sign_in_to_post: "Connecte-toi pour participer",
    critic_videos: "Critiques vidéo",
    critic_videos_sub: "Vidéos de critiques sur YouTube & Instagram.",
    add_video: "Ajouter une critique",
    embed_video: "Colle l'URL YouTube ou Instagram…",
    submit: "Envoyer",
    in_cinemas: "Au cinéma maintenant",
    in_cinemas_sub: "Films à l'affiche cette semaine.",
    buy_tickets: "Acheter billets",
    profile: "Mon profil",
    watchlist: "À voir",
    watched: "Vus",
    following: "Suivis",
    inbox: "Messages",
    for_you: "Pour toi",
    based_on: "D'après tes intérêts en",
    add_to_watchlist: "Ajouter à À voir",
    mark_watched: "Marquer vu",
    follow_title: "Suivre les mises à jour",
    in_watchlist: "Dans la liste",
    marked_watched: "Vu",
    following_btn: "Suivi",
    remove: "Retirer",
    no_watchlist: "Ta liste est vide",
    no_watched: "Tu n'as encore rien marqué comme vu",
    no_following: "Tu ne suis aucun titre",
    no_messages: "Aucune conversation",
    new_message: "Écrire un message…",
    send: "Envoyer",
    locale_picker: "Langue",
  },
};

export function tFor(locale) {
  const dict = DICT[locale] || DICT.en;
  return (key) => dict[key] ?? DICT.en[key] ?? key;
}

export const LOCALE_NAMES = {
  en: "English", tr: "Türkçe", de: "Deutsch", es: "Español", fr: "Français",
};
